/* esm.sh - rxjs@7.8.2/dist/esm/internal/config */
export * from "/*rxjs@7.8.2/esnext/dist/esm/internal/config.mjs";
